import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export const ConfirmDialog = ({
  open, onOpenChange, title, description, confirmLabel = "Confirmar",
  cancelLabel = "Cancelar", onConfirm, destructive = true, loading = false,
  testId = "confirm-dialog",
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid={testId}>
      <AlertDialogHeader>
        <AlertDialogTitle data-testid={`${testId}-title`}>{title}</AlertDialogTitle>
        <AlertDialogDescription data-testid={`${testId}-description`}>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testId}-cancel`}>{cancelLabel}</AlertDialogCancel>
        <AlertDialogAction
          data-testid={`${testId}-confirm`}
          disabled={loading}
          onClick={(e) => { e.preventDefault(); onConfirm(); }}
          className={destructive ? "bg-red-600 hover:bg-red-700 focus:ring-red-600 text-white" : ""}
        >
          {loading ? "Procesando..." : confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
